export const ICONS = {
  error: require('./WarningIcon.web').default,
  warning: require('./WarningIcon.web').default,
  success: require('./CheckmarkIcon.web').default,
}
